import { render, staticRenderFns } from "./month_form_detail.vue?vue&type=template&id=63264484"
import script from "./month_form_detail.vue?vue&type=script&lang=js"
export * from "./month_form_detail.vue?vue&type=script&lang=js"
import style0 from "./month_form_detail.vue?vue&type=style&index=0&id=63264484&prod&lang=less"
import style1 from "./month_form_detail.vue?vue&type=style&index=1&id=63264484&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports